const APP_ZH_TEXT = {
  "1.8 km": "1.8公里",
  "1.2 km": "1.2公里",
  "1008 m²": "1008平方米",
  "1120 m²": "1120 平方米",
  "2.5 km": "2.5公里",
  "2/3 of 45 runes and 40% of 30 runes must glow. How many runes glow in total?": "45 个符文中的 2/3 和 30 个符文中的 40% 必须发光。总共有多少个符文发光？",
  "3 × 2 = 6 magic points.": "3 × 2 = 6 点魔法值。",
  "2/3 of 45 = 30, and 40% of 30 = 12. Total = 30 + 12 = 42.": "45 的 2/3 = 30，30 的 40% = 12。总计 = 30 + 12 = 42。",
  "1260 m²": "1260 平方米",
  "3 boxes": "3盒",
  "3 crystals": "3颗水晶",
  "3.6 km": "3.6公里",
  "4 × 2 = 8 herbs.": "4 × 2 = 8 种草药。",
  "⭐ Stars: {stars}": "⭐ 星星：{stars}",
  "⭐ Étoiles : {stars}": "⭐ 星星：{stars}",
  "4 × 3 = 12 apples.": "4 × 3 = 12 个苹果。",
  "4 × 3 = 12 deer.": "4 × 3 = 12 鹿。",
  "4 × 3 = 12 robots.": "4 × 3 = 12 个机器人。",
  "4 × 5 = 20 monkeys.": "4 × 5 = 20 只猴子。",
  "4 boxes": "4盒",
  "4 × 3 = 12 packs.": "4 × 3 = 12 包。",
  "4 crystals": "4颗水晶",
  "4 groups of 7": "4组，每组7个",
  "4×5=20, while 3×7=21.": "4×5=20，而3×7=21。",
  "4×5=20, while 3×7=21. So 3 crystals gives more energy.": "4×5=20，而3×7=21。所以 3 个水晶可以提供更多的能量。",
  "5 × 2 = 10 eggs.": "5 × 2 = 10 个鸡蛋。",
  "5 × 4 = 20 zombies.": "5 × 4 = 20 只僵尸。",
  "5 × 6 = 30 apples.": "5 × 6 = 30 个苹果。",
  "6 × 2 = 12 survivors.": "6 × 2 = 12 名幸存者。",
  "5 × 6 = 30 symbols.": "5 × 6 = 30 个符号。",
  "5 × 8 = 40 drones.": "5 × 8 = 40 架无人机。",
  "5 × 2 = 10 taxis.": "5 × 2 = 10 辆出租车。",
  "6 × 4 = 24 boxes.": "6 × 4 = 24 个盒子。",
  "6 × 7 = 42 animals.": "6 × 7 = 42 只动物。",
  "6 × 8 = 48 apples.": "6 × 8 = 48 个苹果。",
  "6 × 8 = 48 energy.": "6 × 8 = 48 能量。",
  "6 groups of 5": "6组，每组5个",
  "6 × 8 = 48 packs.": "6 × 8 = 48 包。",
  "7.2 × 25,000 = 180,000 cm = 1,800 m = 1.8 km.": "7.2 × 25,000 = 180,000 cm = 1,800 m = 1.8 km。",
  "6×5=30 while 4×7=28.": "6×5=30，4×7=28。",
  "960 m²": "960 平方米",
  "7×4=28 while 6×5=30.": "7×4=28，6×5=30。",
  "A": "一个",
  "A battery starts at 100%. It loses 12% of full capacity each mission. After 4 missions, how much remains?": "电池电量从 100% 开始。每次任务都会损失 12% 的全部容量。完成 4 次任务后，还剩下多少？",
  "A cave": "一个山洞",
  "A bilingual listening player for TXT, EPUB, MOBI, DOCX, DOC, and PDF, with playback you can keep running while exploring the site.": "支持 TXT、EPUB、MOBI、DOCX、DOC 和 PDF 的双语收听播放器，播放时你仍然可以继续浏览整个网站。",
  "A clue says: 'Switch A does not work. Switch D works only if A works.' Which switch is impossible?": "一条线索说：“开关 A 不起作用。”仅当 A 工作时，开关 D 才工作。哪个开关是不可能的？",
  "A field is 48 m by 35 m. If 3/5 of it is planted with corn, what area is corn?": "场地大小为 48 m x 35 m。如果其中3/5种玉米，那么玉米面积是多少？",
  "A clue says: 'Switch A is broken. Switch D works only if A works.' Which switch is impossible?": "一条线索显示：‘开关 A 坏了。仅当 A 工作时，开关 D 才工作。哪个开关是不可能的？",
  "A Gentle Note": "温柔的音符",
  "A glowing guide named Lumi appears beside you and points toward an ancient signal hidden somewhere in the dark.": "一个名为 Lumi 的发光向导出现在你旁边，并指向隐藏在黑暗中某处的古老信号。",
  "A City Begins to Remember": "一座城市开始记忆",
  "A lake": "一个湖",
  "A map from the city points toward a wildlife reserve where animals from every direction are gathering in strange patterns.": "城市的地图指向一个野生动物保护区，来自四面八方的动物以奇怪的方式聚集在一起。",
  "A message beneath the old tree sends you to a farm where the earth feels cold and the windmill barely turns.": "老树下的一条消息将您带到一个农场，那里的大地感觉寒冷，风车几乎不转动。",
  "A mountain": "一座山",
  "A note on privacy: I do not and cannot collect any information about your child. All game files and analysis are processed entirely on your local device. Please feel free to use this with peace of mind.": "关于隐私的说明：我不会也不能收集有关您孩子的任何信息。所有游戏文件和分析都完全在您的本地设备上处理。请放心使用。",
  "A new destination has appeared: Neon Harbor.": "一个新的目的地出现了：霓虹港。",
  "A robot": "一个机器人",
  "A robot scientist gives you a clue.": "机器人科学家为您提供线索。",
  "A potion changes color when heated.": "药水加热后会变色。",
  "A scanner is best for checking a control panel.": "扫描仪最适合检查控制面板。",
  "A scanner is the most useful tool for studying symbols.": "扫描仪是研究符号最有用的工具。",
  "A spell book is the most useful item for a magical portal.": "法术书是魔法传送门最有用的物品。",
  "A silent planet. A sleeping reactor. The journey begins.": "一个寂静的星球。一个沉睡的反应堆。旅程开始了。",
  "A strange virus has turned many people into zombies. Your mission is to help survivors escape the city.": "一种奇怪的病毒使许多人变成了僵尸。你的任务是帮助幸存者逃离这座城市。",
  "A Story Puzzle Adventure": "故事解谜冒险",
  "A wizard gives you a clue.": "向导会为您提供线索。",
  "Académie de Magie": "魔法学院",
  "accuracy": "准确性",
  "A wildlife reserve has been marked as your next route.": "野生动物保护区已被标记为您的下一条路线。",
  "Accueil": "阿库伊",
  "Accuracy": "准确性",
  "Activate the portal and restore the Wonder Bridge.": "激活传送门并恢复奇迹桥。",
  "Activate the portal": "激活门户",
  "Adventure Complete ⭐": "冒险完成⭐",
  "Adventure Map": "冒险地图",
  "Alien lights blink in a pattern near the ruins.": "废墟附近的外星光芒以某种图案闪烁。",
  "Alien plants glow only at night.": "外星植物只在夜间发光。",
  "After purification, 1,000 bacteria remain. About how many bacteria were there before the cycle?": "纯化后，剩余1,000个细菌。在循环之前大约有多少细菌？",
  "All of them": "他们全部",
  "Analyse": "分析",
  "Amazing! You have passes this WORLD!": "惊人的！你已经通过了这个世界！",
  "Analyse narrative de la session": "分析会议的叙述",
  "Analysis": "分析",
  "analysis": "分析",
  "Analyze the robot network": "分析机器人网络",
  "animals": "动物",
  "Animals gather near the lake in groups.": "动物们成群结队地聚集在湖边。",
  "Animal movement follows a pattern.": "动物的运动遵循一定的模式。",
  "Annuler": "环形器",
  "Anything you want to tell us?": "你有什么想告诉我们的吗？",
  "Apple": "苹果",
  "Are you sure you want to delete all report records?": "您确定要删除所有报告记录吗？",
  "As-tu aimé cette aventure ?": "As-tu aimé cette 冒险？",
  "At sunset, the old windmill finally turns again, and a warm pulse moves through the field. The fourth fragment wakes up — but in the distance, a column of gray mist rises above the city.": "日落时分，古老的风车终于再次转动，温暖的脉搏穿过田野。第四个碎片苏醒了——但在远处，一柱灰色的雾气在城市上空升起。",
  "At the center of the city lies the AI energy core powering everything.": "城市的中心是为一切提供动力的人工智能能源核心。",
  "At the center of the city lies the AI energy core. Lumi recognizes the same pulse you saw on the alien planet. If you stabilize it, the city may reveal where the third fragment has gone.": "城市的中心是AI能源核心。 Lumi 识别出的脉冲与您在外星球上看到的脉冲相同。如果你稳定住它，城市可能会揭示第三块碎片的去向。",
  "At the hover train station, service bots keep rerouting passengers unevenly. Busy districts stay bright, while family neighborhoods flicker and wait in the dark.": "在悬停火车站，服务机器人不断地为乘客重新安排路线。繁忙的地区保持明亮，而家庭社区闪烁并在黑暗中等待。",
  "At the top of the wizard tower you find magical crystals used to power spells.": "在巫师塔的顶部，您可以找到用于为咒语提供动力的魔法水晶。",
  "At the portal, Lumi finally understands the truth: the sixth fragment was never missing. It is awakened by the one who listened, explored, protected others, and chose to reconnect the worlds.": "在传送门处，卢米终于明白了真相：第六块碎片从未失踪。它是由那些倾听、探索、保护他人并选择重新连接世界的人唤醒的。",
  "At the top of the wizard tower, five fragments begin to glow together. The tower shakes softly, but one place in the portal ring is still empty.": "在巫师塔的顶部，五块碎片开始一起发光。塔楼轻轻摇晃，但传送环内有一处仍然是空的。",
  "Aucune donnée de session n'est disponible actuellement.": "Aucune donnée de session n'est 不负责任的行为。",
  "Aucune donnée de session disponible pour le moment.": "立即进行会话。",
  "Aucun défi trouvé ici pour le moment.": "Aucun défi trouvé ici pour le moment。",
  "{world} — Chapitre {level}": "{world} — 章节 {level}",
  "{world} — Chapter {level}": "{world} — 第 {level} 章",
  "Aucune question trouvée pour ce monde pour le moment.": "Aucune Question trouvée pour ce monde pour le moment.",
  "Aucune modification n'a été effectuée.": "Aucune 修改n'a étéeffectuée。",
  "Aventure Animalière": "动物冒险",
  "Aventure terminée ⭐": "冒险终点站⭐",
  "Avis": "安飞士",
  "Aucune donnée de session pour le moment.": "立即进行会议。",
  "B": "乙",
  "Average Accuracy": "平均准确度",
  "Back Home": "返回首页",
  "Back": "后退",
  "Backpack": "背包",
  "Balance the city's failing core.": "平衡城市的失败核心。",
  "Balance the system and bring Neon Harbor back online.": "平衡系统并使 Neon Harbor 重新上线。",
  "Behind the ruins you find an ancient alien energy reactor. It might power your spaceship.": "在废墟后面你会发现一个古老的外星能源反应堆。它可能为你的宇宙飞船提供动力。",
  "Before departure, you must calculate transport capacity correctly.": "出发前，您必须正确计算运输能力。",
  "barn": "谷仓",
  "Back to Map": "返回地图",
  "Begin the Journey": "开始旅程",
  "Beneath the tree roots, you find a message: 'When the ground forgets how to grow, seek the hands that still care for it.' Lumi leads you to a farm where the soil has grown cold and quiet.": "在树根下，你会发现一条信息：“当大地忘记如何生长时，寻找仍然照顾它的双手。”卢米带你来到一个农场，那里的土壤变得寒冷而安静。",
  "Beneath the roots of the old lakeside tree, the third fragment glows like a sleeping seed finally touched by sunlight. Around the lake, animals from different habitats begin to settle and drift apart, no longer frozen by the same uneasy waiting. Carved into a hidden stone, you find a message: 'When the ground forgets how to grow, seek the hands that still care for it.' Lumi reads it twice before looking toward the distant fields.": "在湖边老树的根部下，第三个碎片像一颗沉睡的种子一样发出光芒，最终被阳光触及。在湖的周围，来自不同栖息地的动物开始定居并渐行渐远，不再被同样不安的等待所冻结。在一块隐藏的石头上刻着一条信息：“当大地忘记如何生长时，寻找仍然关心它的双手。”卢米读了两遍，然后看向远处的田野。",
  "Bien joué !": "祝你好运！",
  "Bienvenue dans Wonder World !": "欢迎来到奇幻世界！",
  "Behind the ruins, you discover an ancient energy reactor. If it restarts, your ship may fly again — and Lumi believes it will reveal where the next missing fragment has gone.": "在废墟后面，你发现了一个古老的能源反应堆。如果它重新启动，你的飞船可能会再次飞行——卢米相信它将揭示下一个丢失碎片的去向。",
  "Binoculars help you see things far away.": "双筒望远镜可以帮助您看到远处的事物。",
  "Blanket": "毯子",
  "Beyond the fields, a heavy gray mist has swallowed the city streets and turned them into a maze of fear and confusion.": "田野之外，浓重的灰色雾气吞没了城市街道，把它们变成了恐惧和混乱的迷宫。",
  "Blue": "蓝色的",
  "Blocked road": "道路受阻",
  "Blue key": "蓝键",
  "Boot": "开机",
  "Boots": "靴子",
  "boss": "老板",
  "Boss Puzzles": "首领谜题",
  "Both": "两个都",
  "Both barns": "两个谷仓",
  "Break the door": "打破门",
  "Broken road": "断路",
  "Blue barn": "蓝色谷仓",
  "Brume": "布鲁姆",
  "C": "C",
  "C'était bien": "就这样吧",
  "Cancel": "取消",
  "C'était correct": "正确答案",
  "care": "关心",
  "Care / Responsibility": "关怀/责任",
  "Carte": "点菜",
  "Carte d'Aventure": "冒险卡",
  "Carte des mondes": "世界宪章",
  "Ce défi a été perdu. Retour à l'histoire.": "Ce défi a été perdu。回顾历史。",
  "cave": "洞穴",
  "Ce jeu est né de cette réflexion. J'ai commencé par laisser mon enfant interagir avec l'IA à travers des activités narratives et imaginatives — aventures, choix, énigmes et défis. J'ai constaté que, dans ce cadre ludique, les enfants révèlent souvent leurs centres d'intérêt, leurs façons de raisonner et certains signaux émotionnels beaucoup plus spontanément que dans les conversations du quotidien. Cette observation m'a conduit plus loin : cela pourrait-il aussi aider d'autres familles ?": "Ce jeu est né de cette réflection。我开始与孩子们一起进行各种活动、叙事和想象力——冒险、选择、谜题和挑战。如果是这样，在游戏中，孩子们会在内心深处有一些有趣的纪念品，他们会在日常对话中表现出一些美丽的情感和自发的情感。 Cette 观察 m'a 导管加腰部：cela pourrait-il aussi aider d'autres familles？",
  "Ce n'est pas un devoir. C'est une aventure.": "Ce n'est pas un devoir。这是一次冒险。",
  "Cette action effacera l'historique du Rapport Parent.": "这是父母关系融洽历史中的一个行动。",
  "Ce que tu as débloqué": "Ce que tu as débloqué",
  "Ces observations sont de légères pistes de réflexion sur la manière dont un enfant a réagi pendant le jeu. Ce ne sont ni des étiquettes, ni un test, ni des conclusions définitives.": "对马尼埃滑雪道反射的观察并不像游戏中的“雷阿吉吊坠”那样。这是礼节、测试、结论的定义。",
  "Cette question a expiré après actualisation. Revenez à la carte et continuez l'aventure.": "Cette 质疑实现后的过期时间。点菜并继续冒险。",
  "Challenge Complete": "挑战完成",
  "Challenge": "挑战",
  "Challenge Restored": "挑战恢复",
  "Chapitre terminé": "查皮特终点站",
  "Chapter Complete: Farm Life": "章节完成：农场生活",
  "Chapter Complete": "章节完成",
  "Chapter Complete: Magic Academy": "章节完成：魔法学院",
  "Chapter Complete: Space Exploration": "章节完成：太空探索",
  "Chapter Complete: Urban Sci-Fi": "完成章节：都市科幻",
  "Chapter Complete: Shadow Escape": "章节完成：暗影逃脱",
  "Chapter Complete: Wildlife Adventure": "章节完成：野生动物冒险",
  "Chaque choix ouvre un nouveau monde.": "Chaque choix ouvre un nouveau monde。",
  "Charging means Robot A has power.": "充电意味着机器人A有电。",
  "Chaque choix peut changer le cours de ton histoire.": "查克选择改变历史课程。",
  "Chargez d'abord un livre dans PageTone, puis vous pourrez contrôler la lecture directement depuis l'accueil.": "请先在 PageTone 中加载一本书，然后你就可以直接从主页控制播放。",
  "Check the apple orchard": "检查苹果园",
  "Check the energy supply system": "检查能源供应系统",
  "Checkpoint cleared. The path forward is open.": "检查站已清除。前进的道路是开放的。",
  "Checkpoint cleared. Keep moving toward the boss!": "检查站已清除。继续向boss前进！",
  "Choisir": "乔伊西尔",
  "Choisis ton chemin": "乔伊西斯通化学",
  "Choix d'histoire": "历史选择",
  "Choisis une option ou laisse un message.": "选择选项或自由消息。",
  "Choose": "选择",
  "Choose an option or leave a message.": "选择一个选项或留言。",
  "Choose Your Path": "选择你的道路",
  "City": "城市",
  "Clear Report History": "清除报告历史记录",
  "Climb a hill to observe animals from above": "爬上一座小山，从高处观察动物",
  "Collect glowing plants for research": "收集发光植物进行研究",
  "Collect food supplies": "收集食物供应",
  "Collect apples": "收集苹果",
  "Collect some crystals": "收集一些水晶",
  "Commencer l'aventure": "冒险的开始",
  "Commencer": "入门者",
  "Commencer le défi": "德菲的开始",
  "Commencer le voyage": "航程开始",
  "Comment as-tu trouvé cette aventure ?": "评论 as-tu trouvé cette aventure ？",
  "comparison": "比较",
  "Complete one world first, then come back here.": "先完成一个世界，然后再回到这里。",
  "Continue !": "继续 ！",
  "Continue following the tracks deeper into the forest": "继续沿着小路深入森林",
  "Continue": "继续",
  "Continue the Story": "继续故事",
  "Continuer": "继续",
  "Continuer l'histoire": "历史续篇",
  "control": "控制",
  "cooperation": "合作",
  "Core Stabilized": "核心稳定",
  "core": "核",
  "Core Stabilizer": "核心稳定器",
  "Count clouds": "数云",
  "Count supplies and people": "统计物资和人员",
  "Count the trains arriving": "统计到达的火车",
  "Count the deer carefully": "仔细数鹿",
  "Count the animals in the field": "数一下田野里的动物",
  "Count zombie groups carefully": "仔细清点僵尸群体",
  "creativity": "创造力",
  "Cows": "奶牛",
  "Curiosité": "好奇心",
  "curiosity": "好奇心",
  "Curiosity": "好奇心",
  "Date": "日期",
  "de réussite": "德鲁西特",
  "decision": "决定",
  "Défi": "德菲",
  "Défi restauré": "Défi 餐厅",
  "D": "D",
  "Défi terminé": "德菲终点站",
  "Défis boss": "迪菲斯老板",
  "Delivery robots transport packages.": "送货机器人运输包裹。",
  "Dernière session de jeu": "最后的比赛",
  "Dernière session": "德尔尼埃尔会议",
  "Did you enjoy this adventure?": "你喜欢这次冒险吗？",
  "Durée de la session": "会议期间",
  "Divide by 3: 2x - 5 = 13. Then 2x = 18, so x = 9.": "除以 3：2x - 5 = 13。然后 2x = 18，因此 x = 9。",
  "Each box holds 8 food packs. There are 6 boxes. Total packs?": "每个盒子可容纳 8 个食品包。有6个盒子。总包数？",
  "Each basket holds 8 apples. You fill 6 baskets. Total apples?": "每个篮子里有 8 个苹果。你装满了 6 个篮子。一共苹果吗？",
  "Each bus carries 36 people. There are 5 survivor groups of 8 people each. Minimum number of buses needed?": "每辆巴士载客36人。有 5 个幸存者小组，每组 8 人。最少需要多少辆巴士？",
  "Each crystal gives 8 energy. You have 6 crystals. Total energy?": "每个水晶提供 8 能量。你有 6 个水晶。总能量？",
  "Each chicken lays 2 eggs. You have 5 chickens. How many eggs?": "每只鸡产 2 个蛋。你有 5 只鸡。有多少个鸡蛋？",
  "Each machine builds 3 robots. There are 4 machines. How many robots?": "每台机器建造 3 个机器人。有4台机器。有多少个机器人？",
  "Each group has 7 animals. There are 6 groups. How many animals?": "每组有 7 只动物。有6组。有多少动物？",
  "Each line builds 8 drones per hour. There are 5 lines. Total drones?": "每条生产线每小时生产 8 架无人机。有5条线。全部无人机？",
  "Each potion needs 4 herbs. You make 2 potions. How many herbs?": "每药水需要 4 种草药。你制作 2 剂药水。有多少草药？",
  "Each robot carries 4 boxes. There are 6 robots. Total boxes?": "每个机器人携带 4 个盒子。有6个机器人。总共盒子数？",
  "Each room has 2 survivors. There are 6 rooms. Total survivors?": "每个房间有 2 名幸存者。有6个房间。幸存者总数？",
  "Each station has 5 taxis. There are 2 stations. Total taxis?": "每个车站有5辆出租车。有2个车站。出租车总数？",
  "Each tree has 5 monkeys. There are 4 trees. How many monkeys?": "每棵树有 5 只猴子。有4棵树。有多少只猴子？",
  "Each scroll has 5 symbols. You read 6 scrolls. Total symbols?": "每个卷轴有 5 个符号。你读了6卷。符号总数？",
  "PageTone": "PageTone",
  "Each tree produces 6 apples. There are 5 trees. How many apples?": "每棵树结 6 个苹果。有5棵树。有多少个苹果？",
  "Écrivez votre message ici...": "发送消息 ic...",
  "Écris ton message ici...": "可爱的小兔子图片大全 可爱的小兔子设计素材 可爱的小兔子模板下载 可爱...",
  "Effacer l'historique du rapport": "消除融洽关系的历史",
  "efficiency": "效率",
  "Empty cup": "空杯",
  "Enter the city that is losing power.": "进入正在失去电力的城市。",
  "Envoyer à rootsandbridge@outlook.com": "特使 à rootsandbridge@outlook.com",
  "Escape Secured": "安全逃生",
  "Envoyer l'avis": "拉维斯特使",
  "escape": "逃脱",
  "Étoiles gagnées": "星辰",
  "Étoiles et mondes": "明星与世界",
  "Étoiles obtenues": "获得的星星",
  "Every choice can change where the story goes.": "每一个选择都可能改变故事的走向。",
  "Examine potion shelves": "检查药水架",
  "Every choice opens a new world.": "每一个选择都会打开一个新世界。",
  "Examine the device carefully": "仔细检查设备",
  "Espace": "空间",
  "exploration": "勘探",
  "Exploration": "勘探",
  "Exploration Spatiale": "探索空间",
  "Explore a glowing cave nearby": "探索附近的发光洞穴",
  "Explore l'espace, les forêts, les villes, la magie, et bien plus encore.": "探索空间、森林、城市、魔法等等。",
  "Explore a quiet street": "探索一条安静的街道",
  "Explore space, forests, cities, magic, and more.": "探索太空、森林、城市、魔法等等。",
  "Explore the hover train station": "探索悬停火车站",
  "Farm": "农场",
  "factory": "工厂",
  "Faune": "牧神",
  "Farm Life": "农场生活",
  "Feed the animals": "喂养动物",
  "Feedback": "反馈",
  "Feed the hungry animals": "喂养饥饿的动物",
  "Feeding the animals is the most responsible first step.": "喂养动物是最负责任的第一步。",
  "Find out why the animals are gathering.": "找出动物聚集的原因。",
  "Ferme": "费梅",
  "Five fragments are ready, but the final gate will only open for the one who can reconnect the worlds.": "五个碎片已准备就绪，但最后一扇大门只会为能够重新连接世界的人打开。",
  "Finish today's farm work": "完成今天的农活",
  "Follow a robot delivery route": "跟随机器人送货路线",
  "Follow the animals into silence.": "跟随动物进入沉默。",
  "Follow a trail of moving plants": "追踪移动植物的踪迹",
  "Follow fresh animal footprints": "追踪新鲜的动物足迹",
  "Follow the magic energy flow": "跟随魔法能量流",
  "Follow the map shown in the symbols": "按照符号所示的地图行驶",
  "Food": "食物",
  "Follow the first broken signal.": "遵循第一个损坏的信号。",
  "Food is the most useful choice for survival.": "食物是生存最有用的选择。",
  "For Parents": "致家长",
  "Food pack": "食品包",
  "forest": "森林",
  "Frog": "青蛙",
  "From the hill, you can see birds, deer, and smaller animals all moving in unusual patterns. They are not fleeing randomly. Somehow, they seem to be searching for the same place.": "从山上，您可以看到鸟类、鹿和小型动物都以不寻常的方式移动。他们并不是随意逃跑。不知何故，他们似乎在寻找同一个地方。",
  "Generated At": "生成于",
  "From the hill you see many animals moving across the grassland.": "从山上你可以看到许多动物在草原上移动。",
  "Fuite dans la Brume": "布鲁姆的富特",
  "Généré le": "通用",
  "Gloves": "手套",
  "Glowing only at night suggests they respond to darkness.": "仅在夜间发光表明它们对黑暗有反应。",
  "Gold key": "金钥匙",
  "Good survival planning starts with knowing your resources.": "良好的生存计划始于了解您的资源。",
  "Guide the survivors through the gray mist and secure safe escape.": "引导幸存者穿过灰雾并安全逃脱。",
  "Green": "绿色的",
  "Guide the lost through the gray mist.": "引导迷失者穿过灰色的迷雾。",
  "harvest": "收成",
  "Harvest Engine": "收获引擎",
  "Heat changed the potion": "热量改变了药水",
  "Helmet": "头盔",
  "Help a struggling farm wake the land.": "帮助苦苦挣扎的农场唤醒这片土地。",
  "Help the land recover and secure the fourth fragment.": "帮助收复土地并确保第四块碎片的安全。",
  "hill": "爬坡道",
  "Hide the food": "把食物藏起来",
  "Help the land remember how to grow.": "帮助土地记住如何生长。",
  "Historique supprimé.": "至高无上的历史。",
  "History deleted.": "历史记录已删除。",
  "Home": "家",
  "house": "房子",
  "Hover taxis wait at stations.": "悬浮出租车在车站等候。",
  "Hover trains transport robots across the city.": "悬停列车将机器人运送到城市各处。",
  "How did this adventure feel?": "这次冒险感觉如何？",
  "I wanna say something:": "我想说一句话：",
  "I'll keep working to make Wonder World more fun, more thoughtful, and more trustworthy. Your honest feedback is genuinely welcome.": "我将继续努力，让 Wonder World 变得更有趣、更贴心、更值得信赖。真诚欢迎您提供诚实的反馈。",
  "If A does not work, then D cannot work either.": "如果A不起作用，那么D也不能起作用。",
  "If 90% is removed, 10% remains. 1,000 is 10%, so original amount is 10,000.": "如果除去 90%，则剩下 10%。 1,000 是 10%，因此原始金额为 10,000。",
  "If A is broken, D cannot work.": "如果A坏了，D就不能工作。",
  "If fresh tracks always lead to water, and these tracks are fresh, what is most likely nearby?": "如果新的足迹总是通向水，并且这些足迹是新的，那么附近最有可能的是什么？",
  "If fresh tracks always lead to water, water is the best answer.": "如果新的足迹总是通向水，那么水就是最好的答案。",
  "If it is not red and not green, it must be blue.": "如果它不是红色也不是绿色，那么它一定是蓝色的。",
  "If Robot A is charging and Robot B is not, which robot has power right now?": "如果机器人 A 正在充电而机器人 B 没有充电，那么现在哪个机器人有电？",
  "If the final portal can be opened, the worlds may remember how to connect again.": "如果最终的门户能够打开，世界可能会记住如何再次连接。",
  "If the power is off, the gate cannot open yet.": "如果电源关闭，门还无法打开。",
  "If the needed rune is not active, the portal cannot open yet.": "如果所需的符文未激活，则传送门尚无法打开。",
  "If the silver key opens the library and you need the library, which key should you take?": "如果银钥匙打开图书馆并且你需要图书馆，你应该拿哪把钥匙？",
  "In the bus yard, you find transport, fuel, and an old school crest marked with the symbol of a magic academy. The fifth fragment is close — and the crest may point to the final world.": "在巴士站里，你可以找到交通工具、燃料和一个标有魔法学院标志的旧校徽。第五个碎片已经很接近了——波峰可能指向最终的世界。",
  "Incroyable ! Tu as réussi ce MONDE !": "不可思议！你就像 réussi ce MONDE！",
  "Inside the barn you find tools and baskets for the harvest.": "在谷仓里你可以找到收获的工具和篮子。",
  "Inside the barn, you find tools, baskets, and several families who arrived from the city. They speak of a gray shadow spreading through the streets and forcing people to abandon their homes.": "在谷仓里，你可以找到工具、篮子和几个从城里来的家庭。他们说灰色的阴影在街道上蔓延，迫使人们放弃家园。",
  "Inside the academy portal, the five fragments blaze together, and the missing sixth awakens in response to you. Not hidden in a vault, not lost in a ruin, but waiting in the one who chose to listen, explore, protect, and reconnect. Light pours through the portal ring. Across every world, systems restart, fields soften, forests settle, and the gray mist begins to fold back into silence. The Wonder Bridge lives again.": "在学院大门内，五个碎片一起燃烧，失踪的第六个碎片会响应你的召唤而苏醒。不是隐藏在金库中，不是迷失在废墟中，而是在选择倾听、探索、保护和重新连接的人身边等待。光线穿过传送门环。在每个世界中，系统重新启动，田野软化，森林安定下来，灰色的薄雾开始回归寂静。奇迹桥又复活了。",
  "Inside the cave you see glowing crystals floating in the air. Your scanner says they contain energy.": "在洞穴内，您可以看到发光的晶体漂浮在空气中。你的扫描仪说它们含有能量。",
  "Inside the cave, floating crystals pulse like slow heartbeats. Lumi says this light feels older than your ship — like part of a forgotten signal system.": "洞穴内，漂浮的水晶像缓慢的心跳一样脉动。卢米说，这种光感觉比你的船还要古老——就像被遗忘的信号系统的一部分。",
  "Inside the factory robots assemble new machines every minute.": "在工厂里，机器人每分钟都在组装新机器。",
  "Inside the forest you discover a group of monkeys jumping between trees.": "在森林里，你会发现一群猴子在树间跳跃。",
  "Inside the house you find food supplies and survival gear.": "在房子里你可以找到食物供应和救生装备。",
  "Inside the robot factory, machines are still building, but slower than they should. Some assembly lines have stopped completely, while others keep repeating the same broken command.": "在机器人工厂内，机器仍在建造中，但速度比应有的要慢。一些装配线已经完全停止，而另一些则继续重复相同的损坏命令。",
  "Inspect the assembly lines": "检查装配线",
  "Inside the house, you find food, blankets, flashlights, and notes from a family that left in a hurry. One line is underlined twice: 'The school is still safe. For now.'": "在房子里，你发现了食物、毯子、手电筒和匆忙离开的一家人的笔记。其中一行划了两次下划线：“学校仍然安全。”目前。'",
  "Inspect the orchard rows": "检查果园行",
  "It was okay": "没关系",
  "It was ok": "还好",
  "J'ai adoré": "爱我爱",
  "Je continuerai à améliorer Wonder World pour le rendre plus amusant, plus réfléchi et plus fiable. Vos retours sincères sont les bienvenus.": "我将继续为您带来欢乐、有趣、有趣的奇幻世界。沃斯返回真诚的儿子 les bienvenus。",
  "Jump into magical worlds, solve puzzles, and unlock the next adventure.": "跳入魔法世界，解决谜题，解锁下一次冒险。",
  "L'idée derrière Wonder World": "L'idée derrière 奇幻世界",
  "Keep going!": "继续前进！",
  "La question a été perdue. Retour à l'histoire.": "La Question a été perdue。回顾历史。",
  "lab": "实验室",
  "Inside the forest, monkeys leap from branch to branch above you while the lower paths stay strangely empty. Even the wind feels careful here, like the whole reserve is holding its breath.": "在森林里，猴子在你上方的树枝间跳跃，而下面的小路却出奇地空荡荡。这里连风都感觉很小心，就像整个保护区都屏住了呼吸。",
  "Laissez votre enfant terminer au moins un monde, puis revenez consulter ce rapport.": "孩子们可以自由地在世界各地玩耍，也可以与顾问建立良好的关系。",
  "lake": "湖",
  "Last Bus Plan": "末班车计划",
  "Lakewatch Trial": "守湖审判",
  "Latest Cognitive Profile": "最新认知概况",
  "Latest Play Style": "最新的游戏风格",
  "Latest Session Narrative": "最新会议叙述",
  "Latest Session": "最新会议",
  "Le voyage continue ⭐": "继续航行⭐",
  "Lead survivors through the gray mist.": "带领幸存者穿越灰色迷雾。",
  "Leave the farm": "离开农场",
  "Lead the survivors to safety.": "带领幸存者前往安全地带。",
  "Le projet continue d'évoluer. Beaucoup de personnes qui utilisent cette version me connaissent déjà personnellement ; d'une certaine manière, c'est aussi une expérience ouverte : transformer un défi réel que j'ai vécu en tant que père en quelque chose qui pourrait être utile à d'autres.": "Le projet continue d'évoluer。 Beaucoup de personnes qui utilisent cette version me connaisset déjà personlement ；当然，这也是我们的一次体验：变压器是我的最爱，我的父亲选择了它的用途。",
  "Les observations proposées dans ce jeu visent uniquement à offrir aux parents des pistes de réflexion légères sur la manière dont les enfants réagissent aux histoires et aux défis. Elles ne constituent pas un diagnostic et ne doivent pas être considérées comme des conclusions définitives.": "在游戏中，我们观察到了父母在滑雪道上的独特之处，他们对孩子们的历史和经历进行了反思。这些成分不是诊断性的，也不是考虑到结论定义的。",
  "library": "图书馆",
  "Let your child complete at least one world, then come back here.": "让您的孩子至少完成一个世界，然后再回到这里。",
  "Lights flicker. Systems fail. Something deeper is wrong.": "灯光闪烁。系统失败。更深层次的东西是错误的。",
  "Lizard": "蜥蜴",
  "Load a book in PageTone first, then you can control playback right from the home page.": "请先在 PageTone 中加载一本书，然后你就可以直接从主页控制播放。",
  "Light races through the portal ring as the final fragment awakens in response to you. Across every world, systems recover, forests settle, fields soften, and the gray mist begins to fold back into silence. The Wonder Bridge is alive again — not because you collected power, but because you restored connection.": "当最后的碎片响应你的召唤而苏醒时，光芒会穿过传送门环。在每个世界中，系统都在恢复，森林安定下来，田野软化，灰色的薄雾开始回归寂静。奇迹桥又复活了——不是因为你收集了能量，而是因为你恢复了连接。",
  "Locked": "锁定",
  "logic": "逻辑",
  "Loss is 4 × 12% = 48%, so remaining energy is 100% - 48% = 52%.": "损失为 4 × 12% = 48%，因此剩余能量为 100% - 48% = 52%。",
  "Logic Preference": "逻辑偏好",
  "Loved it": "喜欢它",
  "Lumi discovers that the shadow does not simply attack — it makes people lose their sense of direction, memory, and belonging.": "卢米发现阴影不仅仅会攻击——它还会让人失去方向感、记忆力和归属感。",
  "Lumi senses that nature has noticed the broken Bridge long before anyone else.": "卢米感觉到大自然早在其他人之前就注意到了这座断桥。",
  "Lumi believes the next fragment is hidden inside the mind of the city itself.": "卢米相信下一个碎片隐藏在城市本身的思想中。",
  "Magic": "魔法",
  "Magic Academy": "魔法学院",
  "Magic crystals power the portal.": "魔法水晶为传送门提供动力。",
  "Machines can measure the damage. Nature can feel the pain first.": "机器可以测量损坏程度。大自然最先感受到痛苦。",
  "Magic scrolls contain spell symbols.": "魔法卷轴包含法术符号。",
  "Magie": "玛姬",
  "Map": "地图",
  "Map scale is 1:25,000. Two points are 7.2 cm apart on the map. What is the real distance?": "地图比例为 1:25,000。地图上两点相距 7.2 厘米。真正的距离是多少？",
  "math": "数学",
  "Main Menu": "主菜单",
  "Menu principal": "菜单主体",
  "minutes": "分钟",
  "Mix potion ingredients": "混合药水成分",
  "Monde suivant": "世界报",
  "Monde": "世界报",
  "Neither": "两者都不",
  "Needs more fun": "需要更多乐趣",
  "More stories are waiting on the other side.": "更多的故事在另一边等待着。",
  "Neon Harbor shines again.": "霓虹灯港再次闪耀。",
  "Next": "下一个",
  "Neither barn": "谷仓都没有",
  "Next destination: a city swallowed by gray shadow.": "下一个目的地：被灰色阴影吞噬的城市。",
  "Next destination: a city that has forgotten how to stay bright.": "下一个目的地：一座已经忘记如何保持光明的城市。",
  "Next destination: a farm where the land is growing quiet.": "下一个目的地：一个农场，那里的土地变得越来越安静。",
  "Next destination: a reserve where the animals are gathering in silence.": "下一个目的地：动物们安静地聚集的保护区。",
  "Next destination: the magic academy where the Wonder Bridge was once guarded.": "下一站：曾经守护着奇迹桥的魔法学院。",
  "Nice work!": "干得好！",
  "Next World": "下一个世界",
  "No challenge found here yet.": "此处尚未发现挑战。",
  "No key": "没有钥匙",
  "No question found for this world yet.": "尚未发现这个世界的问题。",
  "No changes were made.": "没有进行任何更改。",
  "No session data is currently available.": "当前没有可用的会话数据。",
  "No session data yet.": "尚无会话数据。",
  "No, delete it anyway": "不行还是删除吧",
  "Noisy road": "嘈杂的道路",
  "Nombre total d'étoiles": "总星号",
  "Nombre total de sessions": "总会话数",
  "Non, le supprimer quand même": "非，le superprimer quand même",
  "Not enough information": "信息不足",
  "Note bienveillante": "注意双维兰特",
  "Not fun": "不好玩",
  "Note sur la confidentialité : je ne collecte pas et ne peux pas collecter d'informations sur votre enfant. Tous les fichiers du jeu et les analyses sont traités uniquement sur votre appareil local. Vous pouvez l'utiliser en toute tranquillité.": "保密注意事项：我不能收集孩子的信息。我们将分析当地服装的独特特征。您完全安静地使用。",
  "Nothing changed it": "一切都没有改变",
  "observation": "观察",
  "Nous n'avons pas pu restaurer complètement cette étape après l'actualisation. Revenez à la carte et redémarrez ce monde.": "Nous n'avons pas pu restaurer complètement cette étape après l'actualization。 Revenez à la carte et redémarrez ce monde。",
  "Observe robot production": "观摩机器人生产",
  "Observe how they move in groups": "观察它们如何成群移动",
  "Observe the animals at the lake": "观察湖边的动物",
  "Open": "打开",
  "Open PageTone": "打开 PageTone",
  "Open Parent Report": "公开家长报告",
  "Open the final gate.": "打开最后一道门。",
  "orchard": "果园",
  "Organize the supplies": "整理物资",
  "Oui, et télécharger le rapport": "我们与您建立融洽的关系",
  "Organize the survivors": "组织幸存者",
  "Ouvert": "乌韦特",
  "Ouvrir PageTone": "打开 PageTone",
  "Ouvrir le rapport parental": "父母的融洽关系",
  "Overall Trend": "整体趋势",
  "Paint the fence": "给栅栏涂漆",
  "Parent Report": "家长报告",
  "Partager un avis": "分享者",
  "Pas amusant": "有趣的事",
  "Pas assez amusant": "有趣的事",
  "pattern": "图案",
  "Pillow": "枕头",
  "Plants need sunlight to grow.": "植物需要阳光才能生长。",
  "planning": "规划",
  "Plastic": "塑料",
  "Play This World Again": "再次玩这个世界",
  "Played": "玩过",
  "Please choose an option or leave a message.": "请选择一个选项或留言。",
  "Plonge dans des mondes magiques, résous des énigmes et débloque la prochaine aventure.": "与魔法世界一起坠入爱河，与前线冒险发生冲突。",
  "Point de contrôle validé. Continue vers le boss !": "有效控制点。继续对老板！",
  "Point de passage validé. Le chemin s'ouvre.": "有效通过点。 Le chemin s'ouvre。",
  "Poster": "海报",
  "portal": "门户网站",
  "Pour les parents": "倾注父母的心",
  "Préférence logique": "逻辑偏好",
  "Portal Ring": "传送门环",
  "Prepare food storage": "准备食物储存",
  "Prepare the final escape plan": "准备最后的逃亡计划",
  "Profil dominant": "轮廓占主导地位",
  "Prepare food for the animals": "为动物准备食物",
  "Profil cognitif récent": "近期认知概况",
  "Progress": "进步",
  "Profile Type": "型材类型",
  "Progress Restored": "恢复进度",
  "Progression": "进展",
  "Progression restaurée": "进步餐厅",
  "question": "问题",
  "Question Restored": "问题已恢复",
  "Question restaurée": "问题餐厅",
  "Question data was lost. Returning to story.": "问题数据丢失。回到故事。",
  "Questions Answered": "问题解答",
  "Questions résolues": "问题解答",
  "Quiet open road": "安静开阔的道路",
  "R&B Studio": "节奏布鲁斯工作室",
  "Rapport": "关系",
  "Rapport parental": "父母关系融洽",
  "Rapport parental Wonder World": "亲子关系融洽的奇幻世界",
  "Rapport téléchargé et historique supprimé.": "电报和历史上的融洽关系。",
  "reactor": "反应堆",
  "Reactor Lock": "反应堆锁",
  "Reactor Restored": "反应堆恢复",
  "Read the pattern at the silent lake.": "在寂静的湖面上阅读图案。",
  "Read the signs of the reserve and uncover the hidden fragment.": "阅读保护区的标志并揭开隐藏的碎片。",
  "Recent Sessions": "最近的会议",
  "Recommandation": "推荐",
  "Recommendation": "推荐",
  "Red": "红色的",
  "Red barn": "红色谷仓",
  "Réessayer": "论文作者",
  "Réflexion sur la session": "会议反思",
  "Rejouer ce monde": "世界万岁",
  "Replay": "重播",
  "Rejouer": "雷茹尔",
  "Report": "报告",
  "Résous des énigmes, gagne des étoiles et débloque de nouveaux mondes.": "Résous des énigmes、gagne des étoiles et debloque de nouveaux mondes。",
  "Restart the ancient reactor.": "重新启动古老的反应堆。",
  "Restore order to the struggling farm.": "恢复陷入困境的农场的秩序。",
  "Restore power in a city that is fading.": "恢复正在衰落的城市的电力。",
  "Restore power to the alien ruins and awaken the first fragment.": "恢复外星废墟的力量并唤醒第一个碎片。",
  "Report downloaded and history deleted.": "下载报告并删除历史记录。",
  "Progress: {done}/{total}": "进度：{done}/{total}",
  "Progression : {done}/{total}": "进展：{done}/{total}",
  "Résumé de l'histoire": "历史概要",
  "Retour": "返程",
  "Retour à l'accueil": "返回目的地",
  "Retour aux mondes": "世界之旅",
  "Return to the Worlds": "返回世界",
  "risk": "风险",
  "Retour à la carte": "返回点菜",
  "Risk": "风险",
  "Risque": "危险的",
  "Robot A": "机器人A",
  "Robot B": "机器人B",
  "Robots are produced in the factory.": "机器人是在工厂生产的。",
  "Rope": "绳索",
  "ruins": "废墟",
  "Run toward the school building": "跑向教学楼",
  "Rock": "岩石",
  "Run toward them quickly": "快速跑向他们",
  "Sandwiches": "三明治",
  "Saving energy helps resources last longer.": "节约能源有助于延长资源的使用寿命。",
  "Scanner": "扫描器",
  "science": "科学",
  "Search an abandoned house": "搜寻废弃房屋",
  "school": "学校",
  "Sci-Fi Urbaine": "科幻城市",
  "Search ancient scrolls": "搜索上古卷轴",
  "Search the basement": "搜查地下室",
  "Search the building for resources": "在建筑物中搜索资源",
  "Search the forest for other animals": "在森林中寻找其他动物",
  "Search the ruins for more clues": "搜索废墟寻找更多线索",
  "Send Feedback": "发送反馈",
  "Session Duration": "会话持续时间",
  "Send to rootsandbridge@outlook.com": "发送至rootsandbridge@outlook.com",
  "Session Reflection": "会议反思",
  "Sessions récentes": "最近的会议",
  "Shadow": "阴影",
  "Shadow Escape": "影子逃脱",
  "Share Feedback": "分享反馈",
  "Sheep": "羊",
  "Shoe": "鞋",
  "Shoes": "鞋",
  "Shout to get attention": "大声喊叫以引起注意",
  "Silver key": "银钥匙",
  "Snake": "蛇",
  "Soin / Responsabilité": "Soin/责任",
  "Solve 3(2x - 5) = 39. What is x?": "求解 3(2x - 5) = 39。x 是多少？",
  "Solve puzzles, earn stars, and unlock new worlds.": "解决谜题、赢得星星并解锁新世界。",
  "Something is wrong with the land, and the people working here are trying to hold everything together.": "这片土地出现了问题，在这里工作的人们正在努力将一切恢复正常。",
  "Sort old boxes": "对旧盒子进行分类",
  "Space": "空间",
  "Space Exploration": "太空探索",
  "Spell book": "咒语书",
  "Stars & Unlocks": "星星和解锁",
  "Spell lights flash in a magical sequence.": "法术灯以魔法顺序闪烁。",
  "Stars Earned": "获得星星",
  "Stabilize the energy core": "稳定能量核心",
  "Start": "开始",
  "Start Adventure": "开始冒险",
  "Start Challenge": "开始挑战",
  "station": "车站",
  "Story Choices": "故事选择",
  "Story Summary": "故事概要",
  "street": "街道",
  "Study a spell book": "学习一本咒语书",
  "Study strange symbols on the cave wall": "研究洞壁上的奇怪符号",
  "Study the crystal energy": "研究晶体能量",
  "Style de jeu récent": "最近的风格",
  "Suivant": "苏万特",
  "Sunlight": "阳光",
  "Ta réponse a aidé la mission à avancer.": "请回复前线任务援助。",
  "Taux de réussite": "红陶",
  "symbols": "符号",
  "Take a nap": "小睡一下",
  "Taux de réussite moyen": "中苏西特",
  "Tendance générale": "一般趋势",
  "Terminez d'abord un monde, puis revenez ici.": "世界的终结，我的复兴。",
  "Thank you, Bridge Keeper. When worlds begin to drift again, the Bridge will know how to find you.": "谢谢你，桥梁守护者。当世界再次开始漂移时，桥梁会知道如何找到你。",
  "That lets you observe without disturbing them.": "这样您就可以在不打扰他们的情况下进行观察。",
  "The AI core stabilizes, and Neon Harbor lights up again in waves of electric blue. Screens across the control tower fill with maps, weather patterns, and animal routes bending in the same strange direction. The city was not the cause of the imbalance. It was only one of the first places to feel it. As the second fragment rises from the core, Lumi turns the wildlife map toward you.": "AI核心稳定下来，霓虹港再次亮起电蓝色的波浪。控制塔的屏幕上充满了地图、天气模式和向同一个奇怪方向弯曲的动物路线。城市并不是造成不平衡的原因。这只是最先感受到它的地方之一。当第二个碎片从核心升起时，卢米将野生动物地图转向你。",
  "The alien forest is full of strange moving plants. Some plants glow softly.": "异星森林里长满了奇怪的会动植物。有些植物发出柔和的光。",
  "The ancient reactor hums back to life, and blue light rushes through the ruins. A hidden signal rises into the sky, carrying the shape of a distant city losing power block by block. Lumi drifts beside you and whispers that this was never only about your crashed ship. The first fragment is awake, and the next world is already calling.": "古老的反应堆恢复了生机，蓝色的光芒穿过废墟。一个隐藏的信号升入天空，呈现出一座遥远城市逐条断电的形状。卢米飘浮在你身边，低声说这不仅仅是关于你失事的船。第一个碎片已经苏醒，下一个世界已经在召唤。",
  "The ancient reactor is sealed behind a final control puzzle.": "古老的反应堆被密封在最终控制谜题后面。",
  "The animals are hungry and waiting.": "动物们都饿了，等待着。",
  "The animals have gathered at the lake for a reason. You must understand the pattern before it disappears.": "这些动物聚集在湖边是有原因的。你必须在它消失之前理解它。",
  "The apple orchard is full, but the leaves look tired and the ground is too dry in some rows and too soft in others. The farm still works, but only because people are working harder than the land itself.": "苹果园已经满了，但叶子看起来很疲倦，有些行的地面太干，有些行的地面太软。农场仍在运转，但只是因为人们比土地本身更努力地工作。",
  "The apple trees are full of fruit ready to harvest.": "苹果树结满了果实，等待收获。",
  "The book changed it": "书改变了",
  "The Bridge Wakes": "桥苏醒",
  "The cave symbols describe an ancient energy network once used to connect distant worlds. A broken map appears in the pattern, pointing toward old ruins beyond the ridge.": "洞穴符号描述了曾经用于连接遥远世界的古老能源网络。图案中出现了一张破损的地图，指向山脊之外的古老废墟。",
  "The city AI core is unstable, and the whole grid depends on your next move.": "城市AI核心不稳定，整个网格取决于你的下一步行动。",
  "The city control center shows something strange: the power problem is not only inside the city. Wildlife routes, weather signals, and traffic systems are all drifting together, as if one hidden force is pulling everything off balance.": "城市控制中心显示出一些奇怪的东西：电力问题不仅仅出现在城市内部。野生动物路线、天气信号和交通系统都在漂移，仿佛一股隐藏的力量正在让一切失去平衡。",
  "The city control core has four switches.": "城控核心有四台交换机。",
  "The alien forest is alive with moving vines and soft blue leaves. Some of the plants seem to lean in one direction, as if they are guiding you toward something important.": "外星森林里充满了移动的藤蔓和柔软的蓝色叶子。有些植物似乎向一个方向倾斜，好像它们正在引导你走向某件重要的事情。",
  "The city core loses energy by a fixed percentage each mission cycle.": "每个任务周期城市核心都会损失固定百分比的能量。",
  "The city core projects a map of a wildlife reserve. Animal paths from every direction are bending toward one quiet lake. Lumi says nature may be feeling the broken bridge before anyone else.": "城市核心投射出野生动物保护区的地图。动物们的小路从四面八方蜿蜒通向一个安静的湖泊。卢米说，大自然可能比任何人都先感受到这座断桥。",
  "The city is not full of monsters. It is full of people who have forgotten the way.": "这座城市并不充满怪物。里面挤满了忘记路的人。",
  "The city lights blink in a repeating pattern.": "城市的灯光以重复的方式闪烁。",
  "The clue says the potion changed when heated.": "线索表明药水在加热时发生了变化。",
  "The clue says the blue barn stores food.": "线索说蓝色谷仓储存食物。",
  "The city runs on energy cells.": "这座城市依靠能源电池运行。",
  "The clue says: 'The safe door is not red and not green.' Which door is safe?": "线索上写着：“保险柜门既不是红色，也不是绿色。”哪扇门安全？",
  "The code does not matter ever": "代码并不重要",
  "The cows and sheep are waiting for food.": "牛羊都在等待食物。",
  "The cows and sheep are waiting, but something feels off. They are calm, yet restless, as if they can sense a storm that has not arrived yet.": "牛和羊正在等待，但感觉有些不对劲。他们平静，却又焦躁，仿佛能感觉到一场尚未到来的暴风雨。",
  "The crest points to the Magic Academy.": "徽章指向魔法学院。",
  "The energy core steadies, and light spreads through the city block by block. But the system logs reveal something bigger: the trouble is not trapped inside the city. Wildlife routes and natural patterns are shifting too, as if the worlds are pulling away from one another.": "能量核心稳定下来，光线在城市中逐个街区蔓延。但系统日志揭示了更大的事情：问题并不在于城市内部。野生动物的路线和自然模式也在发生变化，仿佛世界正在相互远离。",
  "The Fading City": "衰落之城",
  "The escape gate opens only if the power is on and the lock code is correct. The power is off.": "仅当电源打开且锁码正确时，逃生门才会打开。电源已关闭。",
  "The farm can still survive, but only if you restore order before everything gives out.": "农场仍然可以生存，但前提是你在一切耗尽之前恢复秩序。",
  "The farm is ready for the final harvest before sunset.": "农场已准备好在日落前进行最后的收获。",
  "The farmer says the red barn stores tools, not food. The blue barn stores food. You need food.": "农民说红色谷仓存放的是工具，而不是食物。蓝色谷仓储存食物。你需要食物。",
  "The fifth fragment is secured.": "第五个碎片已固定。",
  "The final fragment was never an object. It was the choice to connect worlds that had begun to forget each other.": "最后的碎片从来就不是一个物体。这是连接已经开始互相遗忘的世界的选择。",
  "The Fields Breathe Again": "田野再次呼吸",
  "The final harvest plan requires exact field area calculations.": "最终的收获计划需要精确的田地面积计算。",
  "The first fragment is awake.": "第一个片段是苏醒的。",
  "The First Light": "第一缕曙光",
  "The final bus pulls away, carrying families out of danger. The mist twists behind you, weaker now, as if losing its hold on the people it tried to erase. In the bus yard, you recover the fifth fragment and an old academy crest — the clearest sign yet that the final answer lies elsewhere.": "最后一辆巴士驶离，载着家人脱离危险。雾气在你身后扭曲，现在变得更弱了，仿佛失去了对那些它试图抹去的人的控制。在公交车站，你找到了第五块碎片和一个古老的学院徽章——这是迄今为止最明显的迹象，表明最终答案在别处。",
  "The First Light Returns": "第一缕曙光回归",
  "The forest did not speak with words. It spoke by waiting for someone to notice.": "森林没有说话。它通过等待有人注意到来说话。",
  "The forest reveals its fragment.": "森林露出了它的碎片。",
  "The Forest Was Listening": "森林在倾听",
  "The fragments are ready. The Bridge is waiting.": "碎片已经准备好了。大桥正在等待。",
  "The forest is uneasy, and the lake is waiting.": "森林不安，湖水等待。",
  "The gate cannot open yet": "门还不能打开",
  "The gate is already open": "大门已经打开",
  "The Gray City": "灰色之城",
  "The helmet is part of the life-support system.": "头盔是生命维持系统的一部分。",
  "The hungry animals need urgent care first.": "饥饿的动物首先需要紧急护理。",
  "The Idea Behind Wonder World": "奇幻世界背后的理念",
  "The Journey Continues ⭐": "旅程仍在继续⭐",
  "The Lake Answered": "湖回答了",
  "The land begins to breathe again.": "大地再次开始呼吸。",
  "The Land Takes a Breath": "大地喘口气",
  "The last bus pulls away from the school, carrying families out of the fog. Behind you, the gray mist shifts and curls, not like a monster defeated, but like an emptiness losing its grip. In the bus yard, the fifth fragment and an old academy crest are found together, as if they had been waiting for the same hands to reach them. Lumi studies the crest and finally understands where the road ends.": "最后一班巴士驶离学校，载着家人走出迷雾。在你身后，灰色的雾气移动、卷曲，不像是被击败的怪物，而是像失去控制的虚空。在公共汽车站里，第五块碎片和一个古老的学院徽章被发现在一起，就好像它们一直在等待同一只手到达它们一样。卢米研究了山顶，终于明白了路的尽头。",
  "The Last Gate": "最后的门",
  "The library glows with old books and memory scrolls. They describe the Wonder Bridge not as a road, but as a living link between worlds, held together by trust, courage, and care.": "图书馆里堆满了旧书和记忆卷轴。他们将奇迹桥描述为不是一条路，而是两个世界之间的活生生的纽带，通过信任、勇气和关怀连接在一起。",
  "The library is filled with glowing spell books.": "图书馆里堆满了发光的咒语书。",
  "The next chapter begins inside the shadowed city.": "下一章开始于阴影之城内。",
  "The number doubles each time.": "每次数量都会翻倍。",
  "The observations in this game are meant only to offer parents light reflections on how children respond to stories and challenges. They are not a diagnosis and should not be treated as fixed conclusions.": "这个游戏中的观察结果只是为了让父母对孩子如何应对故事和挑战做出一些简单的思考。它们不是诊断，不应被视为固定结论。",
  "The map says the safe road is not blocked and not noisy.": "地图上写着安全的道路，不堵车，也不吵闹。",
  "The pattern repeats red, blue.": "该图案重复红色、蓝色。",
  "The old windmill groans, then turns with steady strength, and a warm pulse moves through the fields. The fourth fragment shines out from the farm like a small harvest star. But before the feeling of relief can settle, everyone looks up. Far beyond the orchard, a gray column of mist rises over the city. Families who fled there were right to be afraid. Something worse is spreading now.": "古老的风车发出呻吟声，然后以稳定的力量转动，温暖的脉搏穿过田野。第四个碎片像一颗小丰收之星一样从农场中闪耀出来。但还没等松了口气，所有人都抬起头来。果园远处，一股灰色的雾柱升起在城市上空。逃到那里的家庭有理由感到害怕。现在，更糟糕的事情正在蔓延。",
  "The portal cannot open yet": "门户尚无法打开",
  "The portal is already open": "门户已经开放",
  "The portal is broken forever": "传送门永远被破坏了",
  "The portal opens only when two rune groups are activated together.": "仅当两个符文组同时激活时，传送门才会打开。",
  "The portal opens only if the moon rune is active. The moon rune is not active.": "仅当月亮符文处于活动状态时，传送门才会打开。月亮符文未激活。",
  "The portal will open by itself": "门户将自行打开",
  "The potion lab bubbles with magical liquids.": "魔药实验室里充满了魔法液体。",
  "The Quiet Fields": "寂静的田野",
  "The reactor control panel unlocks only if you solve the equation correctly.": "仅当您正确解出方程时，反应堆控制面板才会解锁。",
  "The potion laboratory still bubbles with leftover magic. On one table, you find notes about the gray mist: it does not destroy worlds — it makes them forget one another.": "魔药实验室仍然充满着剩余的魔法。在一张桌子上，你可以找到关于灰雾的注释：它不会毁灭世界——它会让世界彼此忘记。",
  "The reactor roars back to life, and blue energy floods the ruins. Your ship systems begin to recover, but more importantly, the first fragment of the Wonder Bridge finally wakes. A hidden signal rises into the sky, pointing toward a city losing power far away.": "反应堆重新焕发活力，蓝色能量淹没了废墟。你的飞船系统开始恢复，但更重要的是，奇迹桥的第一个碎片终于苏醒了。一个隐藏的信号升入天空，指向远处一座失去电力的城市。",
  "The restored reactor sends you to Neon Harbor, a futuristic city where the lights are going out one district at a time.": "修复后的反应堆将带您前往霓虹港，这是一座未来派城市，其中一个地区的灯光一次熄灭。",
  "The reactor has four switches. Only one opens the gate.": "反应堆有四个开关。只有一个人打开门。",
  "The robot factory produces drones.": "机器人工厂生产无人机。",
  "The safe road must be open and quiet.": "安全的道路必须是开放且安静的。",
  "The school has become a safe shelter for survivors.": "学校已成为幸存者的安全庇护所。",
  "The school has become a shelter full of frightened families. Some people want to leave immediately. Others want to stay hidden. Lumi discovers that the gray mist behaves less like a virus and more like a spreading emptiness.": "学校已成为充满受惊家庭的避难所。有些人想立即离开。其他人则想保持隐藏。卢米发现灰雾的行为不太像病毒，而更像是蔓延的空虚。",
  "The shelter cannot hold forever. You need one clear plan to get people out.": "避难所不可能永远保持下去。你需要一个明确的计划来让人们撤离。",
  "The Silent Reserve": "沉默的储备",
  "The shelter needs help quickly.": "收容所需要尽快获得帮助。",
  "The soil is tired, but the farm is still holding on.": "土壤已经疲倦，但农场仍在坚持。",
  "The story is complete — but the Bridge is open again, and more journeys can begin.": "故事已经结束，但大桥又重新开放了，更多的旅程可以开始。",
  "The street is almost silent except for distant footsteps in the mist. Shapes drift between the buildings, slow and confused. They are not chasing anyone. They are following something unseen.": "街道上几乎一片寂静，只有雾中远处的脚步声。形状在建筑物之间移动，缓慢而混乱。他们不追赶任何人。他们正在追踪一些看不见的东西。",
  "The symbols seem to describe how aliens stored energy long ago.": "这些符号似乎描述了很久以前外星人如何储存能量。",
  "The street is quiet, but you hear zombies in the distance.": "街道上很安静，但你能听到远处传来僵尸的声音。",
  "The table changed it": "表改了",
  "The trail now leads to a struggling farm.": "这条小路现在通向一个苦苦挣扎的农场。",
  "The waiting ends. Beneath the roots of the old tree, the third fragment begins to glow like a waking seed. The animals slowly settle, and a message carved in stone points you toward the next truth: when the land begins to fail, look for the people still caring for it.": "等待结束。在老树的根部下面，第三块碎片开始像一颗醒来的种子一样发光。动物们慢慢安顿下来，刻在石头上的一条信息将你引向下一个真理：当土地开始衰退时，寻找仍在照顾它的人们。",
  "The windmill turns, the fields answer, and the fourth fragment shines out over the farm like a harvest star. For one moment, everything feels steady again. Then the horizon darkens. A gray column of mist rises over the city, and everyone knows the real crisis has arrived.": "风车转动，田野回应，第四个碎片像一颗丰收之星一样闪耀在农场上空。一时间，一切又恢复了平静。然后地平线变暗。城市上空升腾起灰色的雾柱，所有人都知道真正的危机已经到来。",
  "The zombies opened the gate": "僵尸打开了大门",
  "The Wonder Bridge lives again.": "奇迹桥又复活了。",
  "There are 4 cows. Each cow eats 3 apples. How many apples are needed?": "有4头牛。每头牛吃 3 个苹果。需要多少个苹果？",
  "There are 4 groups of deer. Each group has 3 deer. How many deer are there?": "有4群鹿。每组有3只鹿。有多少只鹿？",
  "There are 5 groups. Each group has 4 zombies. Total zombies?": "有5组。每组有 4 只僵尸。全是僵尸？",
  "They are equal": "他们是平等的",
  "These observations are light reflections on how a child responded during play. They are not labels, tests, or fixed conclusions.": "这些观察是对孩子在玩耍过程中如何反应的简单反映。它们不是标签、测试或固定的结论。",
  "They are animals": "他们是动物",
  "They are the same": "他们是一样的",
  "They can fly": "他们可以飞",
  "They may react to darkness": "他们可能会对黑暗做出反应",
  "They are made of metal": "它们由金属制成",
  "This action will clear your Parent Report history.": "此操作将清除您的家长报告历史记录。",
  "This game grew out of that question. I started by letting my child engage with AI through story-driven, imaginative activities — adventures, choices, puzzles, and challenges. I noticed that in these playful settings, children often reveal their interests, thinking patterns, and emotional cues far more naturally than in everyday conversation. That observation led me somewhere bigger: could this become something that helps other families too?": "这个游戏就是从这个问题中诞生的。我首先让我的孩子通过故事驱动的、富有想象力的活动——冒险、选择、谜题和挑战——来接触人工智能。我注意到，在这些有趣的环境中，孩子们经常比日常对话更自然地表达他们的兴趣、思维模式和情感暗示。这一观察让我有了更大的认识：这是否也能帮助其他家庭？",
  "This challenge was lost. Returning to the story.": "这次挑战失败了。回到故事。",
  "This isn't homework. It's an adventure.": "这不是家庭作业。这是一次冒险。",
  "This project is still evolving. Many people using this version already know me personally — so in some ways, this is also an open experiment: turning a real challenge I've faced as a father into something that might be useful to others.": "该项目仍在不断发展。许多使用这个版本的人已经认识我了——所以在某些方面，这也是一个开放的实验：将我作为一名父亲面临的真正挑战转化为对其他人可能有用的东西。",
  "This question expired after refresh. Return to map and continue your adventure.": "这个问题刷新后就过期了。返回地图并继续您的冒险。",
  "Through the Gray Mist": "穿过灰雾",
  "This shadow was never only trying to scare people. It was trying to make them forget who they were, and where they belonged.": "这个影子从来不只是想吓唬人。它试图让他们忘记自己是谁，属于哪里。",
  "Throw food near them": "将食物扔到他们附近",
  "To keep warm": "为了保暖",
  "To make power last longer": "为了让电力持续更长久",
  "To make roads smaller": "使道路变小",
  "To make robots heavier": "让机器人更重",
  "To make sounds louder": "为了让声音更大",
  "To smell plants": "闻植物的气味",
  "To stop math": "停止数学",
  "To see far-away animals clearly": "清晰地看到远处的动物",
  "Ton application e-mail s'est ouverte avec un brouillon.": "大量的应用程序电子邮件是在布劳永（Brouillon）中发现的。",
  "Total people = 5 × 8 = 40. One bus is not enough, so you need 2 buses.": "总人数 = 5 × 8 = 40。一辆巴士不够，所以需要 2 辆巴士。",
  "Total area = 48 × 35 = 1680 m². Corn area = 1680 × 3/5 = 1008 m².": "总面积 = 48 × 35 = 1680 平方米。玉米面积 = 1680 × 3/5 = 1008 平方米。",
  "Total Sessions": "总会话数",
  "Total Stars": "总星星数",
  "tower": "塔",
  "Toy": "玩具",
  "Trace the first signal through alien ruins.": "通过外星废墟追踪第一个信号。",
  "tracks": "曲目",
  "Try Again": "再试一次",
  "Try to activate the reactor": "尝试激活反应堆",
  "Try to decode the symbols": "尝试解码符号",
  "Tu as appris quelque chose d'utile. Continue maintenant l'aventure.": "你作为appris quelque选择了d'utile。继续维护l'aventure。",
  "Tu es un Gardien du Pont": "蓬花园之夜",
  "Turn off all lights and sleep": "关掉所有灯睡觉",
  "Type": "类型",
  "Un lecteur d'écoute bilingue pour TXT, EPUB, MOBI, DOCX, DOC et PDF, avec une lecture qui continue pendant que vous parcourez le site.": "支持 TXT、EPUB、MOBI、DOCX、DOC 和 PDF 的双语收听播放器，播放时你仍然可以继续浏览整个网站。",
  "Type your message here...": "在此输入您的消息...",
  "Une aventure d'histoires et d'énigmes": "历史与冒险的冒险",
  "Unlock the final secret of the Bridge.": "解开大桥的最终秘密。",
  "Urban Sci-Fi": "都市科幻",
  "Use binoculars to count them": "使用双筒望远镜来数它们",
  "Verrouillé": "韦鲁耶",
  "Veux-tu nous dire quelque chose ?": "Veux-tu nous dire quelque 选择了？",
  "Veuillez choisir une option ou laisser un message.": "Veuillez 选择您的选项或放任您的消息。",
  "Vie à la Ferme": "农场生活",
  "View Report": "查看报告",
  "Ville": "维尔",
  "Visit the robot factory": "参观机器人工厂",
  "Visit the spell library": "访问咒语库",
  "Voir le rapport": "融洽之声",
  "Votre application e-mail s'ouvre avec le brouillon du message.": "Votre 应用程序通过电子邮件发送消息。",
  "Voulez-vous vraiment supprimer tous les enregistrements du rapport ?": "您是否愿意为融洽关系登记？",
  "Walk to the potion laboratory": "步行前往药剂实验室",
  "Walk toward a herd of animals": "走向一群动物",
  "Walk toward a strange alien forest": "走向陌生的外星森林",
  "Watch quietly from far away": "远远地静静地观看",
  "We could not fully restore this story step after refresh. Please return to the map and restart this world.": "刷新后我们无法完全恢复这个故事步骤。请返回地图并重新启动这个世界。",
  "We did not just fix a machine. We woke up the first memory of the Bridge.": "我们不只是修理机器。我们唤醒了对这座桥的最初记忆。",
  "We helped the land remember how to breathe. Now we have to help people remember how to find their way back.": "我们帮助这片土地记住如何呼吸。现在我们必须帮助人们记住如何找到回去的路。",
  "Welcome to Wonder World!": "欢迎来到奇幻世界！",
  "Whale": "鲸",
  "Whales are mammals.": "鲸鱼是哺乳动物。",
  "What can you conclude?": "你能得出什么结论？",
  "What comes next? 2, 4, 8, 16, ?": "接下来会发生什么？ 2、4、8、16、？",
  "What comes next? 1, 2, 4, 8, ?": "接下来会发生什么？ 1、2、4、8、？",
  "What comes next? 3, 6, 12, 24, ?": "接下来会发生什么？ 3、6、12、24、？",
  "What comes next? Red, Blue, Red, Blue, ?": "接下来会发生什么？红，蓝，红，蓝，？",
  "What does that suggest?": "这说明什么？",
  "What is the best first step?": "最好的第一步是什么？",
  "What is the best reason to save energy in a city?": "城市节能的最佳理由是什么？",
  "What is the best reason to use binoculars?": "使用双筒望远镜的最佳理由是什么？",
  "What is true right now?": "现在什么是真实的？",
  "What most likely caused the color change?": "最有可能是什么导致颜色变化？",
  "What should you do first?": "你应该先做什么？",
  "What You Unlocked": "你解锁了什么",
  "When the reactor comes online, a hologram points you to Neon Harbor, a futuristic city losing power one block at a time. Lumi says the second fragment may be hidden where the city thinks for itself.": "当反应堆上线时，全息图将您带到霓虹港，这是一座一次一个街区断电的未来城市。卢米说，第二个碎片可能隐藏在城市自己思考的地方。",
  "Which barn should you go to?": "你应该去哪个谷仓？",
  "Which gives more food: 4 boxes with 5 packs each, or 3 boxes with 7 packs each?": "哪个提供更多食物：4 盒每盒 5 包，还是 3 盒每盒 7 包？",
  "Which animal is a mammal?": "哪种动物是哺乳动物？",
  "Which gives more total energy: 4 crystals worth 5 each, or 3 crystals worth 7 each?": "哪个提供更多的总能量：4 个水晶，每个价值 5，还是 3 个水晶，每个价值 7？",
  "Which is greater: 6 groups of 5 animals, or 4 groups of 7 animals?": "哪一个更大：6 组 5 只动物，还是 4 组 7 只动物？",
  "Which is more: 7 sheep eating 4 carrots each, or 6 cows eating 5 apples each?": "哪一个更多：7 只羊每只吃 4 个胡萝卜，还是 6 头牛每只吃 5 个苹果？",
  "Which is the best choice?": "哪个是最好的选择？",
  "Which is the smartest choice?": "哪个是最明智的选择？",
  "Which is the most useful tool?": "哪个是最有用的工具？",
  "Which of these helps astronauts breathe in space?": "其中哪一个可以帮助宇航员在太空中呼吸？",
  "Which of these helps plants grow?": "其中哪些有助于植物生长？",
  "Which road is safest?": "哪条路最安全？",
  "Which task should come first if the animals are still hungry?": "如果动物仍然饥饿，应该先执行哪个任务？",
  "White": "白色的",
  "Which tool is the best choice if you want to study symbols on the wall?": "如果您想研究墙上的符号，哪种工具是最佳选择？",
  "Wildlife Adventure": "野生动物探险",
  "With five fragments in hand, you arrive at a silent academy where the Wonder Bridge was once protected.": "手里拿着五块碎片，你到达了一所寂静的学院，那里曾经是奇迹桥的保护地。",
  "Wildlife": "野生动物",
  "With the school crest in hand, you arrive at a silent magic academy. Lumi says this is where the Wonder Bridge was once watched over. If the final gate opens, every world may remember how to connect again.": "拿着校徽，来到了寂静的魔法学院。卢米说，这里曾经是看守奇迹桥的地方。如果最后一扇门打开，每个世界都可能记得如何再次连接。",
  "Wonder World": "奇幻世界",
  "Wonder World began with something very personal. As a father, I've always wanted to better understand my child's inner world — his thoughts, feelings, and the way he sees things. But as children grow older, many families notice the same quiet gap: everyone cares, yet real conversation doesn't always come easily. For me, language differences made that gap feel even wider. So I kept asking myself: is there a more natural, lower-pressure way for parents to truly understand their children?": "奇迹世界始于一些非常个人化的事情。作为一名父亲，我一直想更好地了解孩子的内心世界——他的想法、感受和他看待事物的方式。但随着孩子年龄的增长，许多家庭注意到同样的安静差距：每个人都关心，但真正的对话并不总是那么容易。对我来说，语言差异让这种差距感觉更大。于是我不断地问自己：有没有一种更自然、更低压的方式让父母真正了解孩子？",
  "Wonder World est avant tout un jeu que les enfants ont réellement envie de jouer. Ce n'est pas un cahier d'exercices déguisé, et les enfants ne doivent jamais avoir l'impression d'être analysés. Ils explorent des histoires, font des choix, résolvent des énigmes, gagnent des étoiles et débloquent de nouveaux mondes. En parallèle, les parents peuvent recevoir quelques observations bienveillantes — par exemple si l'enfant penche plutôt vers l'exploration ou la planification, comment il réagit face à la difficulté, ou quels thèmes l'attirent ou le font hésiter. Ce ne sont ni des étiquettes, ni des conclusions, et ce n'est pas un test psychologique. J'espère simplement que cela pourra servir de point de départ à de meilleures conversations.": "奇迹世界是所有孩子们都羡慕的游戏。这是一本练习手册，让孩子们可以进行印象分析。探索历史、选择字体、解决问题、探索新世界。与此同时，父母们也接受了一些观察——例如，孩子们对探索或规划进行了思考，对困难、服装主题或字体问题进行了评论。这不是礼仪，不是结论，等等都不是心理测试。我希望在出发点进行简单的对话。",
  "Wonder World est né d'une motivation très personnelle. En tant que père, j'ai toujours voulu mieux comprendre le monde intérieur de mon enfant — ses pensées, ses émotions et sa manière de voir les choses. Mais à mesure que les enfants grandissent, beaucoup de familles ressentent le même décalage discret : tout le monde se soucie les uns des autres, mais les vraies conversations ne viennent pas toujours naturellement. Dans mon cas, les différences de langue ont encore accentué ce sentiment. Alors je me suis souvent posé la question : existe-t-il une manière plus naturelle et moins pressante pour aider les parents à vraiment comprendre leurs enfants ?": "奇迹世界并不是人员的动力。和爸爸一样，我要了解孩子们的内心世界——这些想法、这些情感和一些选择的方式。对于孩子们来说，这是一件伟大的事情，对于家庭来说，美丽的事情是要谨慎对待的：世界上所有的人都在与其他人进行交流，所有的对话都与自然有关。在我看来，语言的差异在重演时强调了情感。我是否有这样的问题：存在于自然和帮助父母的生活中？",
  "Wonder World is, first and foremost, a game children actually want to play. It's not a workbook in disguise, and children shouldn't feel like they're being studied. They explore stories, make choices, solve puzzles, earn stars, and unlock new worlds. Along the way, parents may receive a few gentle observations — whether a child leans toward exploration or planning, how they respond to difficulty, what themes draw them in or make them pause. These are not labels or conclusions, and this is not a psychological test. I hope it can simply be a starting point for better conversations.": "Wonder World 首先是一个孩子们真正想玩的游戏。这不是一本变相的练习册，孩子们不应该觉得自己正在被学习。他们探索故事、做出选择、解决谜题、赢得星星并解锁新世界。在此过程中，父母可能会收到一些温和的观察结果——孩子是否倾向于探索或计划，他们如何应对困难，什么主题吸引他们或让他们停下来。这些不是标签或结论，也不是心理测试。我希望它可以成为更好对话的起点。",
  "World": "世界",
  "Wonder World Parent Report": "奇迹世界家长报告",
  "World Map": "世界地图",
  "Write your thoughts here...": "在这里写下你的想法...",
  "Yellow": "黄色的",
  "Yes, and download the report": "是的，并下载报告",
  "You Are a Bridge Keeper": "你是桥梁守护者",
  "You are helping crops grow.": "你正在帮助农作物生长。",
  "You are following tracks through the forest.": "你正沿着足迹穿过森林。",
  "You arrive at a busy farm where animals and crops need care. Your mission is to help the farmer manage the farm.": "你到达一个繁忙的农场，那里的动物和农作物需要照顾。你的任务是帮助农民管理农场。",
  "You arrive at a mysterious magic academy where young wizards learn powerful spells.": "你到达一所神秘的魔法学院，年轻的巫师在那里学习强大的咒语。",
  "You arrive at a peaceful lake where animals from different habitats gather together without fear. Under an old tree near the water, Lumi senses a sleeping fragment hidden beneath the roots.": "您到达一个宁静的湖泊，来自不同栖息地的动物毫无恐惧地聚集在一起。在靠近水边的一棵老树下，卢米感觉到树根下隐藏着一个沉睡的碎片。",
  "You arrive at a vast wildlife reserve filled with amazing animals. Your mission is to observe the animals and help protect the ecosystem.": "您到达了一个广阔的野生动物保护区，里面有很多令人惊叹的动物。您的任务是观察动物并帮助保护生态系统。",
  "You can carry only one thing to the bus.": "您只能携带一件物品上巴士。",
  "You arrive in a futuristic robot city where machines build everything automatically.": "你到达了一个未来的机器人城市，机器自动建造一切。",
  "You can choose one energy source for your scanner.": "您可以为扫描仪选择一种能源。",
  "You can carry only one tool into the ruins.": "你只能携带一件工具进入废墟。",
  "You can only do one thing before sunset.": "日落之前你只能做一件事。",
  "You can prepare only one item before entering the portal.": "在进入门户之前您只能准备一件物品。",
  "You can only bring one tool to fix a robot control panel.": "您只能携带一件工具来修理机器人控制面板。",
  "You collect 3 crystals. Each crystal has 2 magic points. Total power?": "您收集了 3 颗水晶。每个水晶有 2 个魔法点。总功率？",
  "You collect 3 crystals. Each has 2 energy points. Total energy?": "您收集了 3 颗水晶。每个都有 2 个能量点。总能量？",
  "You collect eggs from chickens.": "你从鸡身上收集鸡蛋。",
  "You collect food supplies for survivors.": "你为幸存者收集食物。",
  "You compare two farm deliveries.": "您比较两个农场的交货情况。",
  "You collect magic crystals for a spell.": "你收集魔法水晶来施展法术。",
  "You compare two herds from different parts of the reserve.": "您比较来自保护区不同部分的两个牛群。",
  "You compare two supply options.": "您比较两种供应选项。",
  "You count survivors in the shelter.": "你统计避难所里的幸存者。",
  "You discover a magical portal that requires energy to open.": "你发现了一个需要能量才能打开的神奇门户。",
  "You discover ancient alien ruins with a strange energy device in the center.": "你发现了古老的外星遗迹，中心有一个奇怪的能量装置。",
  "You discover the city control center where robots are managed.": "您会发现管理机器人的城市控制中心。",
  "You entered a failing futuristic city and helped restore its energy core. The second fragment revealed that the problem is not limited to power systems or broken machines. The imbalance is spreading across worlds and into living ecosystems. The trail now leads into the wild.": "你进入了一座衰落的未来城市并帮助恢复了它的能源核心。第二个片段显示问题不仅限于电力系统或损坏的机器。这种不平衡正在蔓延到世界各地并进入生物生态系统。这条小路现在通向野外。",
  "You entered the gray city, protected survivors, and guided them toward safety. The fifth fragment revealed that the spreading shadow is less like a virus and more like a growing emptiness that severs people from memory and belonging. With the academy crest in hand, the path to the final world is finally clear.": "你进入了灰色的城市，保护了幸存者，并引导他们走向安全。第五个片段显示，蔓延的阴影不太像病毒，而更像是一种不断增长的空虚，它切断了人们的记忆和归属感。学院徽章在手，通往最终世界的道路终于清晰。",
  "You feed the cows in the field.": "你在田里喂牛。",
  "You find 4 boxes. Each box has 3 food packs. Total packs?": "你找到4个盒子。每盒有 3 个食品包。总包数？",
  "You find a bus that can take everyone out of the city.": "你找到一辆可以带所有人出城的巴士。",
  "You find three doors inside the alien cave.": "你在外星人洞穴内发现了三扇门。",
  "You follow the footprints and discover several groups of deer near a river.": "您循着脚印，在河边发现了几群鹿。",
  "You follow fresh tracks to a riverbank where deer stand alert and silent. They are not grazing. They are watching the woods, as if waiting for a signal that has not come.": "你沿着新的足迹来到河岸，那里的鹿警觉而沉默。他们不吃草。他们注视着树林，仿佛在等待尚未到来的信号。",
  "You followed broken signals across six worlds. You restored power, listened to the wild, cared for the land, protected the lost, and reopened the final gate. The Wonder Bridge is alive again because you chose not only to solve problems, but to reconnect what had been drifting apart. The worlds are awake. Their stories are no longer separate. And now, they remember you.": "你跟随破碎的信号穿越了六个世界。你恢复了电力，倾听了野性的声音，照顾了土地，保护了失落的人，并重新打开了最后的大门。奇迹桥再次活跃起来，因为你不仅选择解决问题，而且选择重新连接那些已经疏远的事物。世界都醒了。他们的故事不再是分开的。现在，他们记住了你。",
  "You followed the first signal into a broken alien ruin and helped restore an ancient reactor. In doing so, you recovered the first fragment of the Wonder Bridge and discovered that the trouble is spreading far beyond one world. This journey is no longer about escape. It is about connection.": "你跟随第一个信号进入了一座破碎的外星废墟，并帮助修复了一座古老的反应堆。在这样做的过程中，你恢复了奇迹桥的第一块碎片，并发现麻烦已经远远超出了一个世界。这次旅程不再是为了逃避。这是关于连接的。",
  "You harvest apples from the orchard.": "您从果园收获苹果。",
  "You have 5 cells worth 8 energy each. Total energy?": "您有 5 个细胞，每个细胞价值 8 个能量。总能量？",
  "You have become a Bridge Keeper.": "你已成为桥梁守护者。",
  "You helped care for animals, organize supplies, and restore life to a struggling farm. The fourth fragment awakened when the land finally responded, but the victory was short-lived. Refugees from the city brought news of a gray mist that steals direction, memory, and calm. The next chapter is the most dangerous yet.": "您帮助照顾动物、组织物资并让陷入困境的农场恢复生机。当大地终于做出反应时，第四块碎片苏醒了，但胜利是短暂的。来自城市的难民带来了灰雾的消息，灰雾夺走了方向、记忆和平静。下一章是迄今为止最危险的一章。",
  "You learned something useful. Now continue the adventure.": "你学到了一些有用的东西。现在继续冒险。",
  "You load supplies onto the escape bus.": "你将补给品装载到逃生巴士上。",
  "You mix potion ingredients.": "你混合药水成分。",
  "You must estimate real distance to guide rescue teams across the reserve.": "您必须估计实际距离才能引导救援队穿越保护区。",
  "You need the key that opens the library.": "您需要打开图书馆的钥匙。",
  "You observe animals near the lake.": "您观察湖附近的动物。",
  "You observe monkeys jumping between trees.": "你观察到猴子在树间跳跃。",
  "You reach a peaceful lake where animals gather to drink water.": "您到达一个宁静的湖泊，动物们聚集在那里喝水。",
  "You reach ancient alien ruins built around a dormant signal tower. Mirror panels, cracked pathways, and a faint hum suggest the place could still wake up.": "你到达了围绕着一座休眠信号塔建造的古代外星遗迹。镜面板、破裂的通道和微弱的嗡嗡声表明这个地方仍然可以苏醒。",
  "You reach the edge of the city and see the gray mist for yourself. The people wandering through it do not seem like monsters. They look lost, as if the shadow has stolen their memory of where they belong.": "你到达了城市的边缘，亲眼看到了灰色的薄雾。漫步其中的人们看起来并不像怪物。他们看起来迷失了方向，仿佛阴影偷走了他们属于哪里的记忆。",
  "Tu as terminé {world}.": "您作为 {world} 的终点。",
  "Tu as terminé le monde {world}.": "作为 {world} 世界的终点。",
  "You completed the {world} world.": "您已完成 {world} 世界。",
  "You see zombie groups in the street.": "你会在街上看到僵尸群。",
  "You see several deer near the river.": "你在河边看到几只鹿。",
  "You store harvested crops in baskets.": "您将收获的农作物存放在篮子中。",
  "You reached the silent academy and uncovered the truth behind the Wonder Bridge. The final fragment was not something to collect, but something to awaken through courage, care, and connection. With the Bridge restored, all six worlds begin to remember one another, and the journey becomes something larger than survival: it becomes stewardship.": "你到达了寂静的学院并揭开了奇迹桥背后的真相。最后的碎片不是用来收集的东西，而是通过勇气、关怀和联系来唤醒的东西。随着大桥的修复，所有六个世界开始互相记住，这一旅程变得比生存更重要：它变成了管理工作。",
  "You want to protect the animals without disturbing them.": "您想保护动物而不打扰它们。",
  "You use binoculars from the hill.": "您在山上使用双筒望远镜。",
  "You tracked strange animal migrations through the reserve and discovered that nature itself was reacting to the broken Bridge. At the silent lake, you recovered the third fragment and uncovered a clue pointing toward farmland and human care. The journey now moves from wilderness into everyday life.": "您在保护区中追踪了奇怪的动物迁徙，并发现大自然本身正在对断桥做出反应。在寂静的湖边，你找到了第三块碎片，并发现了一条指向农田和人类关怀的线索。现在，旅程从荒野转向日常生活。",
  "Your answer helped the mission move forward.": "您的回答帮助任务取得了进展。",
  "Your email app is opening with the feedback draft.": "您的电子邮件应用程序将打开并显示反馈草稿。",
  "Your email app opened with a draft message.": "您的电子邮件应用程序打开时显示一条草稿消息。",
  "Your engine needs power cells to restart.": "您的发动机需要电池才能重新启动。",
  "Your ship has crash-landed on a distant alien world, and its engine is completely dead.": "你的飞船坠毁在一个遥远的外星世界，它的引擎完全报废了。",
  "Your purifier removes 90% of bacteria in one cycle.": "您的净化器在一个周期内可去除 90% 的细菌。",
  "Your scanner studies the planet sky.": "您的扫描仪研究行星的天空。",
  "Your spaceship crash-lands on a silent alien planet. A tiny glowing guide named Lumi appears and tells you that the Wonder Bridge is breaking apart. Your engine is dead, and the first clue is hidden somewhere nearby.": "你的宇宙飞船迫降在一个寂静的外星球上。一个名叫 Lumi 的微小发光向导出现并告诉你奇迹桥正在破裂。你的引擎坏了，第一个线索就藏在附近的某个地方。",
  "Your spaceship collects small energy crystals.": "你的宇宙飞船收集小型能量晶体。",
  "Your spaceship lands on a mysterious alien planet. Your ship's engine is out of energy. You must explore the planet and find enough energy to restart it.": "你的宇宙飞船降落在一个神秘的外星球上。你的船的引擎没电了。你必须探索这个星球并找到足够的能量来重新启动它。",
  "You completed {world}.": "您已完成 {world}。"
};

export default APP_ZH_TEXT;
